import { enUS } from 'date-fns/locale'
import upperFirst from 'lodash/upperFirst'

import { locales } from '../../../../hooks/useLocale'

export const getMonthNames = (locale?: string) => {
  /* 
  .split is for en-US special handling: locale comes from our date-fns setup (see useLocale.ts)
  and while our regional locales are in a 'xx' format (da, de, fr, nl),
  the US locale is en-US
  */
  const baseLocale = locale?.split('-')[0] || ''
  const localeObject = locales?.[baseLocale] ?? enUS
  const months = []

  for (let i = 0; i < 12; i++) {
    months.push(upperFirst(localeObject.localize?.month(i)))
  }

  return months
}
